import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Alert, Form } from '@themesberg/react-bootstrap';
import { END_POINT_PAYMENT_TERMS } from '../const';
import { showSuccessToast } from '../utils/toast';
import EditFormLayout from '../components/EditFormLayout';
import RecordEditFeedback from '../components/RecordEditFeedback';
import RecordEditActions from '../components/RecordEditActions';
import useRecordEditor from '../hooks/useRecordEditor';

export const PaymentTermEditForm = ({ paymentTermId, onSuccess, onCancel, onSubmittingChange }) => {
  const editor = useRecordEditor({
    recordId: paymentTermId, endpoint: END_POINT_PAYMENT_TERMS, label: 'payment term',
    onSuccess, onSubmittingChange,
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { name: editor.record?.name || '' },
    validationSchema: Yup.object({
      name: Yup.string().trim().required('Payment term is required'),
    }),
    onSubmit: editor.submit,
  });

  if (editor.loading || editor.loadError || !editor.record) {
    return <RecordEditFeedback loading={editor.loading} error={editor.loadError}
      label="payment term" onRetry={editor.retry} onCancel={onCancel} />;
  }

  return (
    <Form noValidate onSubmit={formik.handleSubmit} aria-busy={formik.isSubmitting}>
      {formik.status && <Alert variant="danger">{formik.status}</Alert>}
      <Form.Group className="mb-3" controlId="edit-payment-term-name">
        <Form.Label>Payment Term <span className="text-danger">*</span></Form.Label>
        <Form.Control type="text" autoFocus disabled={formik.isSubmitting}
          {...formik.getFieldProps('name')}
          isInvalid={Boolean(formik.touched.name && formik.errors.name)} />
        <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
      </Form.Group>
      <RecordEditActions formik={formik} backTo="/payment-terms" onCancel={onCancel} />
    </Form>
  );
};

export const EditPaymentTerm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const handleSuccess = result => {
    showSuccessToast(result.message || 'Payment Term updated successfully.');
    navigate('/payment-terms');
  };
  return (
    <EditFormLayout title="Edit Payment Term" subtitle="Update payment term details" backTo="/payment-terms">
      <PaymentTermEditForm key={id} paymentTermId={id} onSuccess={handleSuccess} />
    </EditFormLayout>
  );
};
